import { createGetEndpoint } from '@sonar-software/sonar-http';

export type GetUserInviteLinkRequest = {
    email: string;
};

export type GetUserInviteLinkResponse = {
    link: string;
};

export const getUserInviteLink = createGetEndpoint<GetUserInviteLinkRequest, GetUserInviteLinkResponse>(
	({ email }) => `/api/v2/User/inviteLink?email=${encodeURIComponent(email)}`
);
